<template>
  <!-- 底部 -->
  <div>
    <div class="tit">
      <div class="top_nav">
        <a href="//www.cnxz.com.cn" target="_blank">中国徐州网</a> 
        - <a href="//www.cnxz.com.cn/importNews?id=1&tab=2" target="_blank">徐州新闻</a> 
        - <a href="//video.cnxz.com.cn/importNews?id=1833803344738340864&tab=5" target="_blank">徐州网视</a> 
        - <a style="color:#CC0000" href="//www.xuzhoufabu.com" target="_blank">徐州发布</a> 
        - <a href="//www.cnxz.com.cn/importNews?id=6&tab=6" target="_blank">彭城e评</a>
        - <a href="//www.cnxz.com.cn/topic?tab=11" target="_blank">热点专题</a>
        - <a href="//www.cnxz.com.cn/importNews?id=3&tab=10" target="_blank">健康生活</a> 
        - <a href="//szb.cnxz.com.cn/xzrb/pc/layout" target="_blank">数字报</a></div>
    </div>
    <div class="wptop"></div>
    <div class="menuBg">
      <ul class="menu">
        <li v-for="(item, index) in menuList" @click="goRouter(item)" :key="index">
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'contactUs',
  props: {
    tabIndex: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      menuList: [
        {
          name: '首页',
          link: '/',
        },
        {
          name: '往期回顾',
          link: '/wangqi',
        },
        {
          name: '政务微博',
          link: '/weibo',
        },
        {
          name: '政务微信',
          link: '/weixin',
        },
        {
          name: '汉风号App',
          link: 'http://www.hanfenghao.com/',
        }
      ],
    }
  },
  mounted() {
  },
  methods: {
    goRouter(item, index) {
      window.open(item.link, "_blank");
    },
  }
}
</script>
<style scoped lang="scss">
.tit {
  background: #fff;
  line-height: 32px;
  text-align: center;
  a{
    color: #333333;
    text-decoration: none;
    font-size: 12px;
  }
}

.head_info {
  display: flex;
  justify-content: space-between;
  align-items: end;
  margin: 20px 0;
  border-bottom: 4px solid #E00001;

  .head_info_logo {
    img {
      width: 200px;
    }

    padding-bottom: 10px;

    div {
      display: inline-block;
      margin-left: 20px;
      color: #686B6C;
      font-size: 14px;
      line-height: 24px;

      p {
        &:last-child {
          margin-top: 5px;
        }

        span {
          margin-left: 10px;
        }
      }

      a {
        margin-right: 20px;
        margin-top: 5px;
        color: #E00001;
        font-size: 15.5px;
        cursor: pointer;
        text-decoration: none;

      }

      a:hover {
        text-decoration: dashed;
      }
    }
  }

  .head_seach {
    background: url('http://hfy-img.xzyunchuang.com/a911137c10e6cf276d7f1d9aeaa8d2fb');
  }

}

/deep/ .input-with-select {
  margin: 10px 20px 10px 60px;
  position: relative;
  top: 3px;
  height: 25px;
  line-height: 25px;
  font-size: 13px;
  width: 250px;

  .el-input__inner {
    height: 27px;
    line-height: 27px;
    border-right: none;
  }

  .el-input-group__append {
    height: 25px;
    line-height: 25px;
    background: #fff;
    padding: 0 10px;
    border-color: #fff;
  }
}

.head_icon {
  background: #F0F0F0;
  line-height: 47px;
  padding: 0 20px;
  display: flex;
  color: #686B6C;
  font-size: 17px;
  justify-content: space-between;

  .item_check {
    color: #E00001;
  }

  span {
    cursor: pointer;

    &:hover {
      position: relative;

      &::after {
        content: "";
        width: 100%;
        height: 1px;
        background: #686B6C;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }
  }
}</style>


// WEBPACK FOOTER //
// src/components/indexTab.vue